<template>
  <div id="productListCard">
    <router-link :to="{name:'ProductDetail',query:{VendorProductID:item.VendorProductID}}" class="row py-0" dir="rtl">
      <div class="col-4 p-1 ">
        <v-img :src="$replaceHttps(item.FileUrl)"
               :lazy-src="$replaceHttps(item.FileUrl)"
               aspect-ratio="1" class="rounded-lg  py-1 mx-auto" max-height="150"
               max-width="150">
        </v-img>
      </div>
      <div class="col-6 px-0 d-flex flex-column justify-space-between">
        <div class="primary-text text-truncate">{{ item.Name }}</div>
        <div class="d-flex"><span v-if="item.tip.Discount !== 0" class="product-card-discount rounded-circle m-0">
        {{ item.tip.Discount }} %</span>
          <span v-if="item.tip.Discount !== 0"
                class="font12px pt-2 text-decoration-line-through grey--text mr-3"> {{ item.tip.Price }}</span>
        </div>
        <div class="d-flex justify-space-between">
          <div>{{ $computingPriceOffer(item.tip.Price, item.tip.Discount) }} تومان</div>
          <div class="font12px dark-red-text pt-1" v-if="item.tip.CountAvilable < 10">
            موجودی انبار {{ item.tip.CountAvilable }}
          </div>
        </div>
      </div>
      <div class="col-2 px-1 text-center d-flex flex-column justify-space-between">
        <div><i class="fa-solid fa-star yellow--text ml-1"></i>{{ $roundNum(item.avgVote) }}</div>
        <router-link :to="{path:'StoreProfile',query:{VendorID:item.VendorID}}">
          <v-avatar size="35">
            <img
                :src="$replaceHttps(item.ProductCategorFileUrl)"
                alt="لوگو برند">
          </v-avatar>
        </router-link>
        <div><span class="product-card-bookmark rounded-circle pointer mx-auto"
                   @click.stop.prevent="setBookMark"><i
            :class="productBookmarkActive ? 'red--text fa-solid fa-bookmark' :'fa-light fa-bookmark'"
            class=" fa-lg white--text"></i></span>
        </div>
      </div>
    </router-link>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      <div v-html="resultText"></div>

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
  </div>
</template>

<script>
export default {
  name: "ProductListsCard",
  props: ['item'],
  data: () => ({
    productBookmarkActive: false,
    showLoaderDialog: false,
    showResult: false,
    resultText: '',
    userSaved: []

  }),
  mounted() {
    this.checkUserSaveProduct()
  },
  methods: {
    setBookMark() {
      this.showLoaderDialog = true

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("RelationID", this.item.VendorProductID);
      urlencoded.append("TypeBookMark", "1");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/SetBookMark", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            this.showLoaderDialog = false
            if (resStatus === 200) {
              this.productBookmarkActive = !this.productBookmarkActive
              this.$store.commit('addOrRemoveBookmarkItemToList', this.item.VendorProductID)
            }
            this.resultText = result
            this.showResult = true
          })
          .catch(error => console.log('error', error));
    },
    checkUserSaveProduct() {
      this.userSaved = this.$store.getters.getUserBookmarks
      let saves = this.userSaved
      let id = this.item.VendorProductID
      if (saves.find(x => x.RelationID === id) !== undefined) {
        this.productBookmarkActive = true
      }
    },
  }
}
</script>

<style scoped>

</style>
